import React from "react";
import { useDrag } from "react-dnd";
import { getImageUrl } from "../Helpers/Helpers";

const ItemTypes = {
  PRODUCT: "product",
};

const DraggableProduct = ({ product, currency, isRaccourciMode }) => {
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: ItemTypes.PRODUCT,
      item: { product },
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
    }),
    [product],
  );

  const titre =
    typeof product.titre === "object" ? product.titre.fr : product.titre;

  return (
    <div
      ref={drag}
      className="box"
      style={{
        height: "150px",
        width: "150px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.3s ease",
        position: "relative",
        opacity: isDragging ? 0.5 : 1,
        cursor: "move",
      }}
    >
      <div className="text-center">
        {product.image && product.image.length ? (
          <img
            src={getImageUrl(product.image)}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "images/product/no-image.png";
            }}
            alt={titre}
            style={{
              width: "80px",
              height: "80px",
              objectFit: "cover",
              borderRadius: "8px",
              marginBottom: "10px",
            }}
          />
        ) : (
          <div
            style={{
              width: "80px",
              height: "80px",
              backgroundColor: "#e9ecef",
              borderRadius: "8px",
              marginBottom: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <i className="fa fa-image fa-2x text-muted"></i>
          </div>
        )}
        <h6 className="text-truncate" style={{ maxWidth: "150px" }}>
          {titre}
        </h6>
        {product.prix && (
          <p className="text-success mb-0">
            <strong>
              {product.prix} {currency}
            </strong>
          </p>
        )}
      </div>
    </div>
  );
};

export default DraggableProduct;
